import { render, staticRenderFns } from "./PermissionListAddNew.vue?vue&type=template&id=7bf85f4f&"
import script from "./PermissionListAddNew.vue?vue&type=script&lang=js&"
export * from "./PermissionListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./PermissionListAddNew.vue?vue&type=style&index=0&id=7bf85f4f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports